import { BrowserRouter as Router } from "react-router-dom";
import { AppRoutes } from "./routes";
import { OnlineStatusProvider } from "./Shared/contextOnlineStatus";
import ErrorBoundary from "./services/airbrake";

import "./index.css";
import { AuthProvider } from "./Shared/AuthContext";

const App = () => (
  <ErrorBoundary>
    <Router>
      <AuthProvider>
        <OnlineStatusProvider>
          <AppRoutes />
        </OnlineStatusProvider>
      </AuthProvider>
    </Router>
  </ErrorBoundary>
);

export default App;
